export default __webpack_public_path__ + "static/media/Boots of the Membranous.7dc3463d.jpg";